import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import AdminHeader from '../../../components/header/AdminHeader';
import CallexLoader from '../../../components/CallexLoader';

import { useUserDetails } from '../../../store/slices/authSlice';
import { pbxDtmfListGet, usePbxDtmfList } from '../../../store/slices/tenantSlices/settingSlice';

const PbxDtmf = () => {
  const dispatch = useDispatch();
  const pbxDtmfList = usePbxDtmfList();
  const userDetails = useUserDetails();

  const [isLoading, setIsLoading] = useState(false);
  const handleFormSubmit = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      const payload = {
        company_id: userDetails?.companyId
      };
      await dispatch(pbxDtmfListGet(payload)).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  }, 500);

  useEffect(() => {
    if (userDetails?.companyId) {
      handleFormSubmit();
    }
  }, [userDetails?.companyId]);

  return (
    <div>
      <AdminHeader title="PBX DTMF" isAdd={false} />
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 170px)' }}>
          <CallexLoader />
        </Card>
      ) : pbxDtmfList?.data?.length > 0 ? (
        <Card className="p-0 position-relative m-0">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 170px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th style={{ width: '33.33%' }}>Date</th>
                  <th style={{ width: '33.33%' }}>DTMF</th>
                  <th style={{ width: '33.33%' }}>Type</th>
                </tr>
              </thead>
              <tbody>
                {pbxDtmfList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{val?.date_and_time}</td>
                      <td>{val?.dtmf}</td>
                      <td>{val?.type}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 170px)' }}>
          No data available
        </Card>
      )}
    </div>
  );
};

export default PbxDtmf;
